import CacheBase2 from '../../../services/engines/CacheBase2';

/**
 * Per-instance. Pure state — extends CacheBase2 per Engine Pattern (rk=f03ae8b6).
 * bufferMode: latest -> only the most recent value is kept, always overwritten.
 *
 * NOT a singleton: each CryptoTickerWidget instance (NEAR, BTC, SOL, ... — one per meta.target)
 * owns its own cache, so their state never overwrites each other. The usual singleton-cache
 * pattern (e.g. AttachmentCache) is for shared state across the app — this is the opposite case.
 *
 * CacheBase2/CoreBase call nothing on construction — no auto-init hook exists.
 * Caller must explicitly call initialize() right after `new CryptoTickerCache()`.
 */
class CryptoTickerCache extends CacheBase2 {
  initialize() {
    this._name = 'CryptoTickerCache';
    this._state = null;
    this._listeners = new Set();
  }

  /**
   * Ingest a new payload from the widget's onData. Always overwrites (latest-wins).
   * @param {object} payload
   */
  ingest = (payload) => {
    try {
      this._state = payload;
      this._notify();
    } catch (error) {
      this.logError('ingest', error.message);
    }
  };

  /**
   * @returns {object|null} current state
   */
  getState = () => this._state;

  onDataBufferUpdated = (listener) => {
    this._listeners.add(listener);
  };

  _notify = () => {
    this._listeners.forEach((listener) => listener(this._state));
  };
}

export default CryptoTickerCache;
